
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexunRSNIXtXWyDwa2tThW2QajQJF7574B4wmdhdiJ_fu0Meta } from "/workspace/pages/home/index.vue?macro=true";
import { default as indexCUgytkZQxWZMMUcJerfcUM52ti4JYchdfTAUtqBjDPQMeta } from "/workspace/pages/media/index.vue?macro=true";
import { default as indexYyhHCb7WtoGhOraYIgBSX51dSmfPJgCKGmNMzgZ_45gzoMeta } from "/workspace/pages/stories/index.vue?macro=true";
import { default as indexqWohZq_45Y_458dreCVNkQtmFrpje0pEXshv8S5qaOIyNDwMeta } from "/workspace/pages/insights/index.vue?macro=true";
import { default as indexN2NcUYZO2RdCkklwvt4NpDWXRGV4oqIQp9cHjs6znRgMeta } from "/workspace/pages/scorecards/index.vue?macro=true";
import { default as indextRQzZV9VY9rupQJBvfJANU_sHm1z_8noMh6OZmvyM30Meta } from "/workspace/pages/methodology/index.vue?macro=true";
import { default as _91_46_46_46slug_93_by2Ff5U9s0Wz9WEphSyK_HLL_Xh7f8hP4Hok3cXU3wMeta } from "/workspace/pages/stories/[...slug].vue?macro=true";
import { default as indexXdOSFbaFRFwqyf0rPrMc1T9c3PIIgTHGwFgk1qxfDOAMeta } from "/workspace/pages/meet-the-team/index.vue?macro=true";
import { default as indexFiE_45gMSvpAWC_ciwkwIakSbwPamKUxtXF0eyY3kE2_YMeta } from "/workspace/pages/state-of-cocoa/index.vue?macro=true";
import { default as indexHC2tvz56ChZoKwwDa9ZTpHndnTXyeVoq8GkAAfaUduAMeta } from "/workspace/pages/scorecards/[id]/index.vue?macro=true";
import { default as indexPY60T83WuMzrFtJV2ewdfpWt1V_Sdp_45A3vbsKTyzl70Meta } from "/workspace/pages/the-supply-chain/index.vue?macro=true";
import { default as privateYFYFQq8U6NULVe9oAOpFetz7nPk_PIWoo8vwqfLhuoYMeta } from "/workspace/pages/scorecards/[id]/private.vue?macro=true";
export default [
  {
    name: "home___en",
    path: "/home",
    meta: indexunRSNIXtXWyDwa2tThW2QajQJF7574B4wmdhdiJ_fu0Meta || {},
    alias: ["/"],
    component: () => import("/workspace/pages/home/index.vue")
  },
  {
    name: "home___es",
    path: "/es/home",
    meta: indexunRSNIXtXWyDwa2tThW2QajQJF7574B4wmdhdiJ_fu0Meta || {},
    alias: ["/es"],
    component: () => import("/workspace/pages/home/index.vue")
  },
  {
    name: "home___de",
    path: "/de/home",
    meta: indexunRSNIXtXWyDwa2tThW2QajQJF7574B4wmdhdiJ_fu0Meta || {},
    alias: ["/de"],
    component: () => import("/workspace/pages/home/index.vue")
  },
  {
    name: "home___fr",
    path: "/fr/home",
    meta: indexunRSNIXtXWyDwa2tThW2QajQJF7574B4wmdhdiJ_fu0Meta || {},
    alias: ["/fr"],
    component: () => import("/workspace/pages/home/index.vue")
  },
  {
    name: "home___ja",
    path: "/ja/home",
    meta: indexunRSNIXtXWyDwa2tThW2QajQJF7574B4wmdhdiJ_fu0Meta || {},
    alias: ["/ja"],
    component: () => import("/workspace/pages/home/index.vue")
  },
  {
    name: "media___en",
    path: "/media",
    component: () => import("/workspace/pages/media/index.vue")
  },
  {
    name: "media___es",
    path: "/es/media",
    component: () => import("/workspace/pages/media/index.vue")
  },
  {
    name: "media___de",
    path: "/de/media",
    component: () => import("/workspace/pages/media/index.vue")
  },
  {
    name: "media___fr",
    path: "/fr/media",
    component: () => import("/workspace/pages/media/index.vue")
  },
  {
    name: "media___ja",
    path: "/ja/media",
    component: () => import("/workspace/pages/media/index.vue")
  },
  {
    name: "stories___en",
    path: "/stories",
    component: () => import("/workspace/pages/stories/index.vue")
  },
  {
    name: "stories___es",
    path: "/es/stories",
    component: () => import("/workspace/pages/stories/index.vue")
  },
  {
    name: "stories___de",
    path: "/de/stories",
    component: () => import("/workspace/pages/stories/index.vue")
  },
  {
    name: "stories___fr",
    path: "/fr/stories",
    component: () => import("/workspace/pages/stories/index.vue")
  },
  {
    name: "stories___ja",
    path: "/ja/stories",
    component: () => import("/workspace/pages/stories/index.vue")
  },
  {
    name: "insights___en",
    path: "/insights",
    component: () => import("/workspace/pages/insights/index.vue")
  },
  {
    name: "insights___es",
    path: "/es/insights",
    component: () => import("/workspace/pages/insights/index.vue")
  },
  {
    name: "insights___de",
    path: "/de/insights",
    component: () => import("/workspace/pages/insights/index.vue")
  },
  {
    name: "insights___fr",
    path: "/fr/insights",
    component: () => import("/workspace/pages/insights/index.vue")
  },
  {
    name: "insights___ja",
    path: "/ja/insights",
    component: () => import("/workspace/pages/insights/index.vue")
  },
  {
    name: "scorecards___en",
    path: "/scorecards",
    component: () => import("/workspace/pages/scorecards/index.vue")
  },
  {
    name: "scorecards___es",
    path: "/es/scorecards",
    component: () => import("/workspace/pages/scorecards/index.vue")
  },
  {
    name: "scorecards___de",
    path: "/de/scorecards",
    component: () => import("/workspace/pages/scorecards/index.vue")
  },
  {
    name: "scorecards___fr",
    path: "/fr/scorecards",
    component: () => import("/workspace/pages/scorecards/index.vue")
  },
  {
    name: "scorecards___ja",
    path: "/ja/scorecards",
    component: () => import("/workspace/pages/scorecards/index.vue")
  },
  {
    name: "methodology___en",
    path: "/methodology",
    component: () => import("/workspace/pages/methodology/index.vue")
  },
  {
    name: "methodology___es",
    path: "/es/methodology",
    component: () => import("/workspace/pages/methodology/index.vue")
  },
  {
    name: "methodology___de",
    path: "/de/methodology",
    component: () => import("/workspace/pages/methodology/index.vue")
  },
  {
    name: "methodology___fr",
    path: "/fr/methodology",
    component: () => import("/workspace/pages/methodology/index.vue")
  },
  {
    name: "methodology___ja",
    path: "/ja/methodology",
    component: () => import("/workspace/pages/methodology/index.vue")
  },
  {
    name: "stories-slug___en",
    path: "/stories/:slug(.*)*",
    component: () => import("/workspace/pages/stories/[...slug].vue")
  },
  {
    name: "stories-slug___es",
    path: "/es/stories/:slug(.*)*",
    component: () => import("/workspace/pages/stories/[...slug].vue")
  },
  {
    name: "stories-slug___de",
    path: "/de/stories/:slug(.*)*",
    component: () => import("/workspace/pages/stories/[...slug].vue")
  },
  {
    name: "stories-slug___fr",
    path: "/fr/stories/:slug(.*)*",
    component: () => import("/workspace/pages/stories/[...slug].vue")
  },
  {
    name: "stories-slug___ja",
    path: "/ja/stories/:slug(.*)*",
    component: () => import("/workspace/pages/stories/[...slug].vue")
  },
  {
    name: "meet-the-team___en",
    path: "/meet-the-team",
    component: () => import("/workspace/pages/meet-the-team/index.vue")
  },
  {
    name: "meet-the-team___es",
    path: "/es/meet-the-team",
    component: () => import("/workspace/pages/meet-the-team/index.vue")
  },
  {
    name: "meet-the-team___de",
    path: "/de/meet-the-team",
    component: () => import("/workspace/pages/meet-the-team/index.vue")
  },
  {
    name: "meet-the-team___fr",
    path: "/fr/meet-the-team",
    component: () => import("/workspace/pages/meet-the-team/index.vue")
  },
  {
    name: "meet-the-team___ja",
    path: "/ja/meet-the-team",
    component: () => import("/workspace/pages/meet-the-team/index.vue")
  },
  {
    name: "state-of-cocoa___en",
    path: "/state-of-cocoa",
    component: () => import("/workspace/pages/state-of-cocoa/index.vue")
  },
  {
    name: "state-of-cocoa___es",
    path: "/es/state-of-cocoa",
    component: () => import("/workspace/pages/state-of-cocoa/index.vue")
  },
  {
    name: "state-of-cocoa___de",
    path: "/de/state-of-cocoa",
    component: () => import("/workspace/pages/state-of-cocoa/index.vue")
  },
  {
    name: "state-of-cocoa___fr",
    path: "/fr/state-of-cocoa",
    component: () => import("/workspace/pages/state-of-cocoa/index.vue")
  },
  {
    name: "state-of-cocoa___ja",
    path: "/ja/state-of-cocoa",
    component: () => import("/workspace/pages/state-of-cocoa/index.vue")
  },
  {
    name: "scorecards-id___en",
    path: "/scorecards/:id()",
    component: () => import("/workspace/pages/scorecards/[id]/index.vue")
  },
  {
    name: "scorecards-id___es",
    path: "/es/scorecards/:id()",
    component: () => import("/workspace/pages/scorecards/[id]/index.vue")
  },
  {
    name: "scorecards-id___de",
    path: "/de/scorecards/:id()",
    component: () => import("/workspace/pages/scorecards/[id]/index.vue")
  },
  {
    name: "scorecards-id___fr",
    path: "/fr/scorecards/:id()",
    component: () => import("/workspace/pages/scorecards/[id]/index.vue")
  },
  {
    name: "scorecards-id___ja",
    path: "/ja/scorecards/:id()",
    component: () => import("/workspace/pages/scorecards/[id]/index.vue")
  },
  {
    name: "the-supply-chain___en",
    path: "/the-supply-chain",
    component: () => import("/workspace/pages/the-supply-chain/index.vue")
  },
  {
    name: "the-supply-chain___es",
    path: "/es/the-supply-chain",
    component: () => import("/workspace/pages/the-supply-chain/index.vue")
  },
  {
    name: "the-supply-chain___de",
    path: "/de/the-supply-chain",
    component: () => import("/workspace/pages/the-supply-chain/index.vue")
  },
  {
    name: "the-supply-chain___fr",
    path: "/fr/the-supply-chain",
    component: () => import("/workspace/pages/the-supply-chain/index.vue")
  },
  {
    name: "the-supply-chain___ja",
    path: "/ja/the-supply-chain",
    component: () => import("/workspace/pages/the-supply-chain/index.vue")
  },
  {
    name: "scorecards-id-private___en",
    path: "/scorecards/:id()/private",
    component: () => import("/workspace/pages/scorecards/[id]/private.vue")
  },
  {
    name: "scorecards-id-private___es",
    path: "/es/scorecards/:id()/private",
    component: () => import("/workspace/pages/scorecards/[id]/private.vue")
  },
  {
    name: "scorecards-id-private___de",
    path: "/de/scorecards/:id()/private",
    component: () => import("/workspace/pages/scorecards/[id]/private.vue")
  },
  {
    name: "scorecards-id-private___fr",
    path: "/fr/scorecards/:id()/private",
    component: () => import("/workspace/pages/scorecards/[id]/private.vue")
  },
  {
    name: "scorecards-id-private___ja",
    path: "/ja/scorecards/:id()/private",
    component: () => import("/workspace/pages/scorecards/[id]/private.vue")
  }
]